// extracted by mini-css-extract-plugin
module.exports = {"title":"GlobalFooter_ExploreColumn_title","list":"GlobalFooter_ExploreColumn_list","option":"GlobalFooter_ExploreColumn_option","chevron":"GlobalFooter_ExploreColumn_chevron"};